'use client'
import DropdownLink from './dropdown-link'
import NavLink from './nav-link'
import React from 'react'
import { useLocale } from '~/contexts/LocaleContext'
import { useMenuItems } from '~/hooks/use-menu-items'
import { buildMenuTree } from '~/utils/menu-tree'

interface DesktopNavProps {
  isScrolled: boolean
  pathname: string
}

export default function DesktopNav({ isScrolled, pathname }: DesktopNavProps) {
  const { locale } = useLocale()
  const { data: menuItems = [] } = useMenuItems(locale)
  // Chuyển đổi menuItems sang dạng MenuItems để buildMenuTree
  const menuTree = buildMenuTree(menuItems)
  const listActive = menuTree.filter((r) => r.showMenu)
  return (
    <nav className="font-body hidden items-center gap-12 md:flex">
      {listActive.map((link) => (
        <React.Fragment key={link.href}>
          {link.children ? (
            <DropdownLink link={link} isScrolled={isScrolled} pathname={pathname} />
          ) : (
            <NavLink link={link} isScrolled={isScrolled} pathname={pathname} />
          )}
        </React.Fragment>
      ))}
    </nav>
  )
}
